import { Component, ViewChild } from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { AuthService } from '../auth/auth-service';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ButtonModule } from 'primeng/button';
interface Column {
  field: string;
  header: string;
  customExportHeader?: string;
}

interface ExportColumn {
  title: string;
  dataKey: string;
}
@Component({
  selector: 'app-details',
  imports: [CommonModule, TableModule, ButtonModule, IconFieldModule, InputTextModule, InputIconModule],
  templateUrl: './details.html',
  styleUrl: './details.css',
})
export class Details {
  studentsDetails: any = [];
  cols!: Column[];
  exportColumns!: ExportColumn[];

  isLoading: boolean = true;
  @ViewChild('dt') dt!: Table;
  constructor(private auth: AuthService) { }

  ngOnInit() {
    this.auth.getAllRegisteredStudents().then((data: any) => {
      this.studentsDetails = data;
      this.isLoading = false;
      console.log(this.studentsDetails);

      this.cols = [
        { field: 'name', header: 'Name' },
        { field: 'email', header: 'Email' },
        { field: 'createdAt', header: 'Date' },
        { field: 'phoneNumber', header: 'Phone Number' },
        { field: 'collegeName', header: 'College Name' },
        { field: 'universityName', header: 'University Name' },
        { field: 'degreeandBranch', header: 'Degree And Branch' },
        { field: 'passingYear', header: 'Passing Year' },
        { field: 'isVerified', header: 'Verified' },

      ];

      this.exportColumns = this.cols.map((col) => ({ title: col.header, dataKey: col.field }));
      console.log(this.exportColumns);
    }).catch((err: any) => {
      console.error(err);
    });
  }
  exportData() {
    if (this.dt) {
      this.dt.exportCSV();
    } else {
      console.error("p-table instance not found.");
    }
  }
}
